import React from 'react';
import { View } from 'react-native';
import { SportActivityCard as SportActivityResponseCard } from '~/chat/components/responses/SportActivityCard';
import { PresentationCaption } from './PresentationCaption';

interface SportActivityCardProps {
  caption?: string | null;
  sportActivityId: string;
}

interface SportActivityCardSyncedProps {
  payload: Record<string, unknown>;
}

interface SportActivityPayload {
  caption?: string | null;
  sportActivityId?: string;
}

/**
 * `present_sport_activity` → a catalog-exercise card (name + category +
 * muscle-group badge). Reuses the existing self-fetching response card.
 */
export const SportActivityCard: React.FC<SportActivityCardProps> & {
  Synced: React.FC<SportActivityCardSyncedProps>;
} = ({ caption, sportActivityId }) => (
  <View className="w-full py-2 gap-2">
    <PresentationCaption caption={caption} />
    <SportActivityResponseCard.Synced id={sportActivityId} />
  </View>
);

const SportActivityCardSynced: React.FC<SportActivityCardSyncedProps> = ({
  payload,
}) => {
  const { caption, sportActivityId } = payload as SportActivityPayload;

  if (!sportActivityId) {
    return null;
  }

  return (
    <SportActivityCard caption={caption} sportActivityId={sportActivityId} />
  );
};

SportActivityCard.Synced = SportActivityCardSynced;
